export const Loader = () => {
  return <img src="/assets/loader.svg" />;
};
